module.exports = "/_next/static/images/bottom-banner-app-sp-0938a6b93224ee0fb8386f6e85bb4076.jpg";